export default __webpack_public_path__ + "static/media/2Fujitsu.50c1c3f3.svg";